import { editVendorUnifiedSchema } from "../../../../services/schemas/accountSchemas";

export function getProfileErrorMap(issues) {
  const nextErrors = {};
  for (const issue of issues) {
    const fieldName = issue.path?.[0];
    if (fieldName && !nextErrors[fieldName]) {
      nextErrors[fieldName] = issue.message;
    }
  }
  return nextErrors;
}

export function validateVendorForm(vendorForm) {
  if (Object.keys(vendorForm).length === 0) {
    return { profileSchemaValid: true, fieldErrors: {} };
  }
  const parsed = editVendorUnifiedSchema.safeParse(vendorForm);
  if (parsed.success) {
    return { profileSchemaValid: true, fieldErrors: {} };
  }
  return { profileSchemaValid: false, fieldErrors: getProfileErrorMap(parsed.error.issues) };
}
